import UserClickContext from 'shared/contexts/UserClickContext'
import { FC, ReactNode, useState } from 'react'

type Props = {
  children: ReactNode
  initialValue?: boolean
}

const UserClickDataProvider: FC<Props> = ({
  children,
  initialValue = false
}) => {
  const [clicked, setClicked] = useState(initialValue)

  return (
    <UserClickContext.Provider value={{ clicked, setClicked }}>
      {children}
    </UserClickContext.Provider>
  )
}

export default UserClickDataProvider
